import { toast } from 'sonner';
import { useEffect, useState } from 'react';

import { Button } from '@/components/ui/button';
import { Checkbox } from '@/components/ui/checkbox';
import { useOrganization, useUpdateOrganization } from '../api/organization-api';
import { Field, FieldGroup, FieldLabel, FieldLegend, FieldSet } from '@/components/ui/field';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

const modules = [
  ['imaging', 'Imaging'],
  ['calendar', 'Calendar'],
  ['upload_schedule', 'Upload Schedule'],
  ['billing', 'Billing'],
] as const;
export function ModuleVisibility() {
  const { data: org } = useOrganization();
  const update = useUpdateOrganization();
  const [hidden, setHidden] = useState<string[]>([]);
  useEffect(() => {
    setHidden(Array.isArray(org?.settings?.hidden_modules) ? (org.settings.hidden_modules as string[]) : []);
  }, [org]);
  return (
    <Card>
      <CardHeader>
        <CardTitle>Visible modules</CardTitle>
        <CardDescription>
          Choose which optional modules appear in navigation for everyone in this organization. Hiding a module keeps
          its data and permissions unchanged.
        </CardDescription>
      </CardHeader>
      <CardContent className="flex flex-col gap-4">
        <FieldSet>
          <FieldLegend>Show in navigation</FieldLegend>
          <FieldGroup className="grid gap-3 sm:grid-cols-2">
            {modules.map(([id, label]) => (
              <Field key={id} orientation="horizontal" className="rounded-md border p-3" data-disabled={!org || update.isPending}>
                <Checkbox id={`module-${id}`} checked={!hidden.includes(id)} disabled={!org || update.isPending}
                  onCheckedChange={(checked) => setHidden(current => checked === true ? current.filter(value => value !== id) : [...current, id])} />
                <FieldLabel htmlFor={`module-${id}`}>{label}</FieldLabel>
              </Field>
            ))}
          </FieldGroup>
        </FieldSet>
        <Button
          className="self-start"
          disabled={!org || update.isPending}
          onClick={async () => {
            try {
              await update.mutateAsync({ hidden_modules: hidden });
              toast.success('Module visibility saved');
            } catch {
              toast.error('Could not save module visibility');
            }
          }}>
          {update.isPending ? 'Saving…' : 'Save module visibility'}
        </Button>
      </CardContent>
    </Card>
  );
}
